export default {
    name: 'ButtonSave',
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
    },
};